<template>
  <div class="bg-white">
    <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
      <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6 max-w-sm">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500">{{ adminDetail.id }}</p>
        </div>
        <div class="mb-6 ">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama</label>
          <p class="text-neutral-500">{{ adminDetail.name }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No Handphone</label>
          <p class="text-neutral-500">-</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Role</label>
          <p class="text-neutral-500">{{ adminDetail.role }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Permission</label>
          <p class="text-neutral-500 mb-1" v-for="permission in adminDetail.permissions" :key="permission.id">{{ permission.id }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Alamat Email</label>
          <p class="text-neutral-500">{{ adminDetail.email }}</p>
        </div>
      </div>
      <div class="flex-1 mdmax:flex-auto mdmax:w-full">
        <!-- <div class="p-6 ">
          <p class="font-bold text-lg mb-6">Password</p>
          <div class="mb-6">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Password</label>
            <div class="relative">
              <TextField :type="passwordState.fieldType" v-model="payloads.password" placeholder="Masukan password" />
              <span class="inline-block cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2" @click="showPassword(passwordState)">
                <component :is="passwordState.icon" />
              </span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="flex gap-6 p-6 justify-end">
      <Button buttonText="Hapus" @action="submit()" type="delete" :size="isMobile ? 'full' : 'regular'" />
      <Button buttonText="Edit" @action="edit()" :size="isMobile ? 'full' : 'regular'" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const EyeOpen = () => import(/* webpackChunkName: "icon" */ '@/components/Icons/EyeOpen')
const EyeClose = () => import(/* webpackChunkName: "icon" */ '@/components/Icons/EyeClose')
export default {
  components: {
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "form" */ '@/components/Forms/Button')
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      payloads: {
        id: '012',
        name: null,
        phoneNumber: null,
        email: null,
        selectedRole: '',
        password: '123',
        confirmPassword: '123'
      },
      passwordState: {
        fieldType: 'password',
        hidden: true,
        icon: EyeOpen
      },
      confirmPasswordState: {
        fieldType: 'password',
        hidden: true,
        icon: EyeOpen
      }
    }
  },
  computed: {
    ...mapGetters('role', ['roleList']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('admin', ['adminDetail']),
    userId() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.getUserInformation()
    if (this.mode === 'edit') {
      // this.getPartnerInformartion()
    } else {
      this.getRole()
    }
  },
  methods: {
    ...mapActions('role', ['getRoleList']),
    ...mapActions('admin', ['getAdminDetail']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getRole() {
      this.getRoleList({
        params: {
          page: 1,
          per_page: 50,
          search_keyword: ''
        }
      })
        .then(res => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    getUserInformation() {
      this.getAdminDetail({
        id: this.userId
      })
    },
    showPassword(field) {
      field.hidden = !field.hidden
      if (field.hidden) {
        field.fieldType = 'password'
        field.icon = EyeOpen
      } else {
        field.fieldType = 'text'
        field.icon = EyeClose
      }
    }
  }
}
</script>
